import { createAsyncThunk } from '@reduxjs/toolkit';
import GetSistemAlertDataService from 'modules/inbound/entriesST12/application/getSistemAlertDataUseCase';
import {
  ColumnSelected,
  Sort
} from 'modules/shared/layout/components/TableHeader/types';
import { getSelectedColumn } from './index';
const getSystemAlertData = createAsyncThunk(
  'entriesST12/getSystemAlertData',
  async (_, { getState }) => {
    const appState = getState();
    const defaultSortOrderQuery = `{license_plate:ASC||provider_name:ASC}`;
    const selectedColumn: ColumnSelected = getSelectedColumn(appState);
    const sortOrder = selectedColumn.isAscending ? Sort.ASC : Sort.DESC;
    const sort = `{${selectedColumn.key}:${sortOrder}}`;
    const getSortOrderQuery = () => {
      return sort;
    };

    const queryParams = {
      sort: selectedColumn.key.length
        ? getSortOrderQuery()
        : defaultSortOrderQuery
    };
    const response = await GetSistemAlertDataService.execute({ queryParams });
    return response;
  }
);

export { getSystemAlertData };
